
import HomeView from './logic/HomeView';
export default HomeView;
